import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./AddRouteAssign.css";

// components
import PageHeader from "../../../components/common/PageHeader/PageHeader";
import CloseButton2 from "../../../components/common/CloseButton/CloseButton2";
import InputBoxLarge from "../../../components/common/InputBox/InputBoxLarge";
import { getRouteAssign, RouteDetail } from "../../../services/routeApi";
import { formatDate } from "../../../utils/dates";
import { useTranslation } from "react-i18next";
import EditButton from "../../../components/common/EditButton/EditButton";
import DocumentActions from "../../../components/common/Action-icons/DocumentActions";
import ActivityLogIcon from "../../../components/common/Action-icons/ActivityLogIcon";
import { showAlert } from "../../../components/common/ErrorAlert/ErrorAlert";

const RouteAssignDetails = () => {
    const [routeInterval, setRouteInterval] = useState([]);
    const [routeType, setRouteType] = useState();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [routesAssign, setRouteAssign] = useState({});
    const { id } = useParams();
    const [animateEdit, setAnimateEdit] = useState(false);

    useEffect(() => {
        if (id) {
            fetchRouteAssignDetail(id);
        }
    }, [id]);

    const fetchRouteAssignDetail = async (id) => {
        try {
            const response = await getRouteAssign(id);
            if (response?.data?.success === true) {
                const respData = response.data.data;
                setRouteAssign(respData); // ← store full object, not flattened
                if (respData?.route?.id) {
                    fetchRouteDetail(respData.route.id);
                }
            }
        }catch(e){
            if (e?.response?.data?.error_code === 1001) navigate("/error");
        }
    };

    const fetchRouteDetail = async (id) => {
        try{
            const response = await RouteDetail(id);
            if (response?.data?.success === true) {
                const respData = response.data.data;
                setRouteInterval(respData.route_intervals);
                setRouteType(respData.route_type);
            }
        }catch(e){
            if (e?.response?.data?.error_code === 1001){
                showAlert(e?.response?.data?.message)
            }
        }
    };

    const handleClose = () => {
        navigate("/routes/assign");
    };

    const handleEditButtonClick = () => {
        navigate(`/routes/assign/edit/${id}`);
    };

    // animation
    const triggerEditAnimation = () => {
        setAnimateEdit(true);
        setTimeout(() => setAnimateEdit(false), 800);
    };

    const capitalize = (text) =>
        text ? text.charAt(0).toUpperCase() + text.slice(1) : "";

    return (
        <div className="whole-container"
        onClickCapture={(e) => {
                if (
                e.target.tagName === "INPUT" ||
                e.target.tagName === "TEXTAREA" ||
                e.target.classList.contains("input-box") ||
                e.target.classList.contains("text-box") ||
                e.target.closest(".input-box") ||
                e.target.closest(".text-box")
                ) {
                triggerEditAnimation();
                }
            }}
        >
            <div className="path-header">
                <PageHeader
                    breadcrumbs={[
                        { label: "Route Management" },
                        { label: "Route Assignment", path: "/routes/assign" },
                        { label: "Details" },
                    ]}
                />
            </div>
            <div className="page-actions-bar">
                <div className="name-utility">
                    <div className="title-heading">
                        {t("Route Assignment Details")}
                    </div>
                    <DocumentActions />
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="2"
                        height="17"
                        viewBox="0 0 2 17"
                        fill="none"
                    >
                        <path d="M1 0V17" stroke="#CDCDCD" />
                    </svg>
                    <ActivityLogIcon/>
                </div>
                <div className="page-name-rightside-icons">
                    <EditButton 
                    animate={animateEdit}
                    onClick={handleEditButtonClick} />
                    <CloseButton2 onClick={handleClose} />
                </div>
            </div>

            <div style={{ marginTop: "1rem" }}>
                <div className="add-fields-section route-assignment-container">
                    <div className="add-fields-50-card">
                        <InputBoxLarge
                            label="Route"
                            defaultValue={routesAssign?.route?.name || ""}
                            readOnly
                        />
                        <InputBoxLarge
                            label="Sales Person"
                            defaultValue={
                                routesAssign?.sales_person?.full_name ||
                                routesAssign?.sales_person?.name ||
                                ""
                            }
                            readOnly
                        />
                        
                        <InputBoxLarge
                            label="Start Date"
                            defaultValue={formatDate(routesAssign?.start_date)}
                            readOnly
                        />
                        <InputBoxLarge
                            label="End Date"
                            defaultValue={formatDate(routesAssign?.end_date)}
                            readOnly
                        />
                    </div>

                    <div className="route-preview-box">
                        <div className="route-preview-header">{t("Route Preview")}</div>
                        <div className="route-preview-body">
                            <table>
                                <thead>
                                    <tr>
                                        {routeType === "weekly" && <th>{t("Day")}</th>}
                                        <th>{t("Customers")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {routeInterval && routeInterval.length > 0 ? (
                                        routeInterval.map((interval, index) => (
                                            <tr key={index}>
                                                {routeType === "weekly" && (
                                                    <td>{capitalize(interval.interval)}</td>
                                                )}
                                                <td>
                                                    <div className="customer-card-container">
                                                        {interval.stop_data.map((s, idx) => (
                                                            <div key={s.id || idx} className="cust-card">
                                                                {s.label}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={routeType === "weekly" ? 2 : 1}>
                                                <div className="empty-body">
                                                    No route intervals selected
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RouteAssignDetails;